module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bucket-9bb40a2ce57797972461c945a83bfdbc.svg";